import { ListingsAppProps } from '@/types';

export const getLocaleFromProps = (props: Pick<ListingsAppProps, 'pageProps' | 'requestLocale'>): string => {
  return props.pageProps.locale || props.requestLocale || 'en-US';
};
